import { FormattedDateTime, Row, Table } from '@elotech/components';
import { AssinaturaDigital } from 'common/type';

import { QuickView } from '../quick-view';
import { TableContainer } from '../table';
import styles from './pdfSignatureQuickView.module.css';

type Props = {
  fileName?: string;
  onClose: () => void;
  signatures: AssinaturaDigital[];
};

export const PdfSignatureQuickView = ({
  fileName,
  onClose,
  signatures
}: Props) => (
  <QuickView onClose={onClose} fixed mobileScroll={false} width={700}>
    <QuickView.Header>
      <Row>
        <QuickView.Item
          size={12}
          header="Arquivo"
          value={fileName || 'Não informado'}
        />
      </Row>
    </QuickView.Header>
    <div className={styles.content}>
      <TableContainer classNames={styles.tableContainer}>
        <Table values={signatures}>
          <Table.Column<AssinaturaDigital>
            header="Assinatura"
            value={(_, index) => `Assinatura ${index + 1}`}
          />
          <Table.Column<AssinaturaDigital>
            header="Dados Assinante"
            value={assinatura => assinatura.nome || 'Não informado'}
          />
          <Table.Column<AssinaturaDigital>
            header="Data e hora"
            align="center"
            value={assinatura =>
              assinatura.dataHora ? (
                <FormattedDateTime value={assinatura.dataHora} />
              ) : (
                'Não informado'
              )
            }
          />
          <Table.Column<AssinaturaDigital>
            header="Observações"
            align="center"
            value={assinatura => assinatura.motivo || 'Não informado'}
          />
        </Table>
      </TableContainer>
    </div>
  </QuickView>
);
